import {
  Menu,
  MenuTrigger,
  MenuPopover,
  MenuList,
  MenuItem,
  Button,
  makeStyles,
  tokens,
} from '@fluentui/react-components';
import { GlobeRegular, CheckmarkRegular } from '@fluentui/react-icons';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles({
  button: {
    color: tokens.colorNeutralForegroundOnBrand,
    minWidth: 'auto',
  },
  icon: {
    color: tokens.colorNeutralForegroundOnBrand,
  },
});

export default function LanguageSwitcher() {
  const styles = useStyles();
  const { i18n, t } = useTranslation();

  const currentLang = i18n.language.startsWith('en') ? 'en' : 'de';

  const changeLanguage = (lang: string) => {
    i18n.changeLanguage(lang);
  };

  return (
    <Menu>
      <MenuTrigger disableButtonEnhancement>
        <Button
          className={styles.button}
          appearance="transparent"
          icon={<GlobeRegular className={styles.icon} />}
          size="medium"
          aria-label={t('language.label')}
        />
      </MenuTrigger>
      <MenuPopover>
        <MenuList>
          <MenuItem
            icon={currentLang === 'de' ? <CheckmarkRegular /> : undefined}
            onClick={() => changeLanguage('de')}
          >
            {t('language.german')}
          </MenuItem>
          <MenuItem
            icon={currentLang === 'en' ? <CheckmarkRegular /> : undefined}
            onClick={() => changeLanguage('en')}
          >
            {t('language.english')}
          </MenuItem>
        </MenuList>
      </MenuPopover>
    </Menu>
  );
}
